import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from '../AdminSidebar';
import AdminHeader from '../AdminHeader';
import { useSidebar } from '../../../contexts/SidebarContext';
import ProductShell from '../product/ProductShell';

const AdminLayout = () => {
  const { isAdminSidebarCollapsed, isAdminMobileSidebarOpen } = useSidebar();

  return (
    <ProductShell>
      <div className="product-shell-row">
        <AdminSidebar />
        <div
          className={`product-main ${
            isAdminSidebarCollapsed ? 'is-collapsed' : ''
          } ${isAdminMobileSidebarOpen ? 'is-mobile-open' : ''}`}
        >
          <div className="product-main-frame">
            <AdminHeader />
            <main className="dashboard-main flex-1 min-w-0">
              <div className="product-page min-w-0 max-w-full">
                <Outlet />
              </div>
            </main>
          </div>
        </div>
      </div>
    </ProductShell>
  );
};

export default AdminLayout;
